const initScrollListBlock = () => {
  if(document.querySelector('.sand-scroll-list')){
    const contentBlocks = document.querySelectorAll('.sand-content-block');
    const pictures = document.querySelectorAll('.sand-scroll-list--picture');
    const textBlockInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const elementTop = rect.top;
      const elementBottom = rect.bottom;

      const topThreshold = viewportHeight * 0.5; // 50% von der Höhe des Viewports
      const bottomThreshold = viewportHeight * 0.75; // 50% von der Höhe des Viewports

      return (
        elementTop <= (viewportHeight - topThreshold) &&
        elementBottom >= bottomThreshold
      );
    }
    const changeImage = () => {
      let windowWidth = window.innerWidth || document.documentElement.clientWidth;
      for (let i = contentBlocks.length - 1; i >= 0; i--) {
        let block = contentBlocks[i];
        if (textBlockInViewport(block)) {
          const blockId = block.id;
          let activeEle = document.querySelector('.sand-scroll-list--picture[data-block="' + blockId + '"]');
          if (!activeEle.classList.contains('active')) {
            for (let j = 0; j < pictures.length; j++) {
              let element = pictures[j];
              element.classList.remove('active');
            }
            activeEle.classList.add('active');
          }
          if(windowWidth < 992){
            const links = document.querySelectorAll('.sand-item-links .sand-item-link');
            links.forEach(function(element) {
              // Perform actions on each element
              element.classList.remove('active');
            });
            let activeLink = document.querySelector('.sand-item-link[data-link="' + blockId + '"]');
            activeLink.classList.add('active');
          }
        }
      }
    }
    window.addEventListener('scroll', changeImage);
    window.addEventListener('resize', changeImage);
    window.addEventListener('load', changeImage);
  }
};
export default initScrollListBlock;






